var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcquiredStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.991,
    height: 53.827,
    viewBox: "0 0 41.991 53.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#2e2d79}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1627",
    "data-name": "Group 1627",
    transform: "translate(-7116.709 -17205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__icons8-mobile-shopping-payment",
    d: "M26.851 1A5.84 5.84 0 0 0 21 6.851a1.35 1.35 0 1 0 2.7 0A3.131 3.131 0 0 1 26.851 3.7h22.886a3.131 3.131 0 0 1 3.151 3.151 1.326 1.326 0 0 0 1.35 1.35h.519a1.326 1.326 0 0 0 1.35-1.35A5.84 5.84 0 0 0 50.257 1zm27.387 4.5a1.326 1.326 0 0 0-1.35 1.35v42.126c0 1.755-3.127 3.151-4.882 3.151H26.851a3.131 3.131 0 0 1-3.151-3.151V28.231a1.35 1.35 0 0 0-2.7 0v20.745a5.84 5.84 0 0 0 5.851 5.851h23.406a5.84 5.84 0 0 0 5.851-5.851V6.851a1.326 1.326 0 0 0-1.35-1.35z",
    className: "prefix__cls-1",
    transform: "translate(7102.592 17204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__icons8-mobile-shopping-payment-2",
    d: "M63.317 106a2.317 2.317 0 1 0 2.317 2.317A2.317 2.317 0 0 0 63.317 106z",
    className: "prefix__cls-1",
    "data-name": "icons8-mobile-shopping-payment",
    transform: "translate(7076.928 17141.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__icons8-mobile-shopping-payment-3",
    d: "M32.551 61.8a1.249 1.249 0 0 1 .928.4l4.5 4.5a1.3 1.3 0 0 1 .405.946 1.27 1.27 0 0 1-.18.675.661.661 0 0 1-.225.27l-4.5 4.5a1.337 1.337 0 0 1-1.89-1.891l2.611-2.6a14.3 14.3 0 0 0-13.638 8.011 1.349 1.349 0 0 1-2.431-1.17A17.071 17.071 0 0 1 33.39 65.9l-1.8-1.8a1.306 1.306 0 0 1 0-1.891 1.36 1.36 0 0 1 .961-.409z",
    className: "prefix__cls-1",
    "data-name": "icons8-mobile-shopping-payment",
    transform: "translate(7098.709 17152.111)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcquiredStep3);
export default __webpack_public_path__ + "static/media/acquired-step3.e9abcc5f44a2cc8ae0c627d7b5cfeadd.svg";
export { ForwardRef as ReactComponent };